<span id="first-focus-element"></span>
<rcl-header id="landing-page-rcl-header" [bg]="brandName" [expandable]="false">
	<a id="landing-page-rcl-header__go-to-brand" href="" aria-haspopup="true" (click)="goToBrandUrl($event)"
		tabindex="0">
		<img id="landing-page-rcl-header__go-to-brand__logo" class="{{ brandName }}-header-logo"
			src="assets/icons/{{ brandName }}-logo.svg"
			alt="{{ brandCorpAltText }} Home" />
	</a>
	@if (shouldDisplayMessageCenter && screensize().isdesktop) {
		<rcl-header-extra-option>  
			<main-nav-message-center [messageCenterIcon]="true"></main-nav-message-center>
		</rcl-header-extra-option>
	}
	<rcl-menu-button id="landing-page-rcl-header__rcl-menu" [text]="bundle() && bundle()['user.menu.label.my.account']"
		[expanded]="showMenu" (onToggleNav)="toggleShowMenu()">
	</rcl-menu-button> 

	@if (!isSafari) {
		<rcl-menu-button-dropdown id="landing-page-rcl-header__rcl-menu-dropdown">
				<app-user-menu [(showMenu)]="showMenu" [bundle]="bundle()" [displayMessageCenter]="screensize().isphone && shouldDisplayMessageCenter" (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
		</rcl-menu-button-dropdown>
	}
</rcl-header>

@if (isSafari) {
	<app-user-menu id="landing-page__user-menu" [(showMenu)]="showMenu" [bundle]="bundle()" [displayMessageCenter]="screensize().isphone  && shouldDisplayMessageCenter"  (displayBadgeOnProfileMenu)="displayBadgeOnProfile($event)" [hideMessageCenterContainer]="hideMessageCenterContainer"></app-user-menu>
}

<rcl-main-content id="landing-page__rcl-main-content">
	<app-error-wrapper></app-error-wrapper>
	@for (alert of alertMessages; track alert.id) {
		<rcg-notification-message
			[brand]="brandName"
			[notificationId]="alert.id"
			[type]="alert.type"
			[description]="alert.message"
			[dismissible]="alert.closable"
			[iconUrl]="alert.iconUrl"
			[customStyles]="alert.customStyles"
			[variant]="'inline'"
		></rcg-notification-message>
	}

	@if (isAppEnabled) {
		<section class="rcl-row app-banner-main-content" [class.mobile-content]="!screensize().isdesktop"  tabindex="0">
			<div class="rcl-col-md-12 rcl-col-sm-12 app-banner-rectangle">
				<div class="rcl-row">
					<div class="rcl-col-md-8 rcl-col-sm-12" [ngClass]="{'rcl-col-md-12': !screensize().isdesktop}">
						<h1 class="app-banner-header" tabindex="0">
							{{ bundle() && bundle()['label.mobile.app.download.required'] }}
						</h1>

						@if (!screensize().isdesktop) {
							<div class="rcl-row app-banner-store-buttons" [attr.tabindex]="0">
								@if (device !== constants.DEVICE_TYPE.DESKTOP) {
									<div class="rcl-col-sm-12">
										@if (isAppleDevice) {
											<div class="rcl-col-sm-12">
												<a id="appstore" title="app-store" (click)="trackDeepLink(constants.OS_TYPE.IOS)"
													[href]="mobileAppLinks.unified" target="_blank">
													<img class="app-banner-download-img-width"
														src="assets/images/download-appstore.png"
														alt="App Store Button" />
												</a>
											</div>
										}
										@if (isAndroidDevice) {
											<div class="rcl-col-sm-12">
												<a id="googleplay" title="google-play"
													(click)="trackDeepLink(constants.OS_TYPE.ANDROID)"
													[href]="mobileAppLinks.unified">
													<img class="app-banner-download-img-width"
														src="assets/images/download-googleplay.png"
														alt="Google Play Button" />
												</a>
											</div>
										}
									</div>
								}
								@if (device === constants.DEVICE_TYPE.DESKTOP) {
									<div class="rcl-col-sm-12">
										<a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener"
											(click)="trackDeepLink(constants.OS_TYPE.IOS)" target="_blank">
											<img class="app-banner-download-img-width"
												src="assets/images/download-appstore.png"
												alt="App Store">
										</a>
										<a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener"
											(click)="trackDeepLink(constants.OS_TYPE.ANDROID)" target="_blank">
											<img class="app-banner-download-img-width"
												src="assets/images/download-googleplay.png"
												alt="Google Play">
										</a>
									</div>
								}
							</div>
						}

						<ul class="app-banner-subheader rcl-col-md-12 rcl-col-sm-12"  tabindex="0">
							<li>{{ bundle() && bundle()['label.access.digital.boarding.pass'] }}</li>
							<li>{{ bundle() && bundle()['label.answer.health.check'] }}</li>
							<li>{{ bundle() && bundle()['label.embark.safely'] }}</li>
						</ul>
						@if (screensize().isdesktop) {
							<div class="rcl-col-row">
								<div class="app-banner-download-buttons">
									<a id="appstore" title="app-store" [href]="mobileAppLinks.ios" rel="noopener"
										(click)="trackDeepLink(constants.OS_TYPE.IOS)" target="_blank">
										<img class="app-banner-download-img-width app-banner-download-img-margin"
											src="assets/images/download-appstore.png"
											alt="App Store">
									</a>
									<a id="googleplay" title="google-play" [href]="mobileAppLinks.android" rel="noopener"
										(click)="trackDeepLink(constants.OS_TYPE.ANDROID)" target="_blank">
										<img class="app-banner-download-img-width"
											src="assets/images/download-googleplay.png"
											alt="Google Play">
									</a>
								</div>
							</div>
						}
					</div>
					@if (screensize().isdesktop) {
						<div class="rcl-col-md-4 app-banner-static-img">
							<img class="app-banner-iphone-static-img" id="landing-page__rcl-main-content__static-mobile-app"
								src="assets/images/iphone-{{ brandName }}.png"
								alt="Mobile Boarding Pass">
						</div>
					}
				</div>
			</div>
		</section>
	}

	@if (checkInGuestSelectBanner()) {
		<section
			id="governance-content-banner" 
			class="rcl-row" 
			(click)="openGovernanceContentModal()"
				[attr.tabindex]="checkInGuestSelectBanner() ? 0 : -1"
			(keydown.enter)="openGovernanceContentModal()"
		>
			<div class="banner-container banner-container-{{ brandName }}">
				<div class="banner-alert-icon-container banner-alert-icon-container-{{ brandName }}">
					<div>
						<img class="alert-icon-banner" src="assets/icons/alert_icon.svg" alt="alert icon" />
					</div>
				</div>
				<div class="banner-content">
					<h2 class="rcl-h2 rcl-section-header-title banner-content-headline">{{ bundle() && bundle()['label.guestselect.safety.headline'] }}</h2>
					<p class="rcl-section-header-description banner-content-subcopy">{{ bundle() && bundle()['label.guestselect.safety.subcopy'] }}</p>
				</div>
				<div class="banner-right-arrow-container">
					<img class="right-arrow-banner" src="assets/icons/arrow-right.svg" alt="arrow right icon"/>
				</div>
			</div>
		</section>
	}

	@if (session() && !session()?.sailingClosed && guestsCompleted().length > 0) {
		<ng-container id="landing-page__rcl-main-content__checked-in-guests">
			<rcl-section-header id="landing-page__rcl-main-content__checked-in-guests__header"
				[class.rcl-header-box]="isCubaItinerary">
				<rcl-section-title id="landing-page__rcl-main-content__checked-in-guests__header__title">
					{{ bundle() && bundle()['landing.page.title.checked.in.guests'] }}
				</rcl-section-title>
				<rcl-section-description id="landing-page__rcl-main-content__checked-in-guests__header__description">
					{{ bundle() && bundle()['landing.page.subtitle.checked.in.guests'] }}
				</rcl-section-description>
			</rcl-section-header>
		</ng-container>
	}

	@if (session() && session()?.sailingClosed) {
		<ng-container id="landing-page__rcl-main-content__check-in-closed">
			<rcl-section-header id="landing-page__rcl-main-content__check-in-closed__header"
				[class.rcl-header-box]="isCubaItinerary">
				<rcl-section-title id="landing-page__rcl-main-content__check-in-closed__header__title">
					{{ bundle() && bundle()['error.check.in.closed.header'] }}
				</rcl-section-title>
				@if (guestsCompleted().length > 0) {
					<rcl-section-description id="landing-page__rcl-main-content__check-in-closed__header__description">
						{{ bundle() && bundle()['error.check.in.closed.subtitle'] }}
					</rcl-section-description>
				}
			</rcl-section-header>
		</ng-container>
	}

	@if (isCubaItinerary && !guestsCompleted().length) {
		<ng-container id="landing-page__rcl-main-content__guests-completed">
			<div class="rcl-row">
				<div class="rcl-col-sm-12">
					 <rcg-notification-message
						[brand]="brandName"
						[variant]="'inline'"
						[type]="'info'"
						[notificationId]="'isCubaItinerary'"
						[description]="cubaItineraryMessage"
						[dismissible]="false"
						[iconUrl]="'assets/images/flag-cuba.png'"
						[customStyles]="customStyles"
					></rcg-notification-message> 
				</div>
			</div>
		</ng-container>
	}

	@for (bookingId of bookingIdsOfCompletedGuests; track bookingId) {
		@if (guestsCompleted().length > 0) {
			<div class="rcl-row rcl-guest-checkin-completed-selector-title">
				<div class="rcl-col-sm-12">
					<h3 class="rcl-h3">
						{{ bundle() && bundle()['label.reservation.title'] }} - {{ bookingId }}
						@if (guestsService.isGuestLocked(guestsCompletedGrouped[bookingId][0])) {
							<rcl-guest-action-status>{{ bundle() && bundle()['guest.booking.unavailable.label'] }}
							</rcl-guest-action-status>
							<rcl-tooltip [id]="'UnavailableTip1'" [buttonText]="bundle()['button.okay']"
								[tooltipDescription]="bundle()['tooltip.locked.booking']">
								<div>{{ bundle() && bundle()['tooltip.locked.booking'] }}</div>
							</rcl-tooltip>
						}
					</h3>
				</div>
			</div>
		}
		<app-guest-checkin-completed [guestsCompleted]="guestsCompletedGrouped[bookingId]" [session]="session()"
			[bundle]="bundle()">
		</app-guest-checkin-completed>
	}

	@if (session() && !session()?.sailingClosed && guestsNotCompleted().length > 0) {
		<ng-container id="landing-page__rcl-main-content__select-guests">
			<div class="rcl-guests-not-completed">
				<rcl-section-header id="landing-page__rcl-main-content__select-guests__header">
					<rcl-section-title id="landing-page__rcl-main-content__select-guests__header__title">{{
						bundle() && bundle()['landing.page.title.select.guests']
						}}</rcl-section-title>
					<rcl-section-description id="landing-page__rcl-main-content__select-guests__header__description">{{
						bundle() && bundle()['landing.page.subtitle.select.guests']
						}}</rcl-section-description>
				</rcl-section-header>
			</div>

			@if (isCubaItinerary && !guestsCompleted().length) {
				<ng-container id="landing-page__rcl-main-content__select-guests__guest-completed">
					<div class="rcl-row">
						<div class="rcl-col-sm-12">
							<rcg-notification-message
								[brand]="brandName"
								[variant]="'inline'"
								[type]="'info'"
								[notificationId]="'isCubaItinerary'"
								[description]="cubaItineraryMessage"
								[dismissible]="false"
								[iconUrl]="'assets/images/flag-cuba.png'"
								[customStyles]="customStyles"
							></rcg-notification-message>
						</div>
					</div>
				</ng-container>
			}

			@for (bookingId of bookingIdsOfNotCompletedGuests; track bookingId) {
				<div class="rcl-row rcl-guest-not-completed-selector-title">
					<div class="rcl-col-sm-12">
						<h3 class="rcl-h3">
							{{ bundle() && bundle()['label.reservation.title'] }} - {{ bookingId }}
							@if (guestsService.isGuestLocked(guestsNotCompletedGrouped[bookingId][0])) {
								<rcl-guest-action-status>{{ bundle() && bundle()['guest.booking.unavailable.label'] }}
								</rcl-guest-action-status>
								<rcl-tooltip [id]="'UnavailableTip2'" [buttonText]="bundle()['button.okay']"
									[tooltipDescription]="bundle()['tooltip.locked.booking']">
									<div>{{ bundle() && bundle()['tooltip.locked.booking'] }}</div>
								</rcl-tooltip>
							}
						</h3>
					</div>
				</div>
				<app-guest-selection-for-checkin [bundle]="bundle()"
					[guestsNotCompleted]="guestsNotCompletedGrouped[bookingId]" (selectItem)="selectItem($event)"
					(onSubmit)="addAssociatedToReservation()" (associateGuests)="addAssociatedToReservation()">
				</app-guest-selection-for-checkin>
			}

		<div>	
			<rcl-button-group>
				<div>
					<rcg-primary-button
						type="button" 
						text="{{ bundle()['button.continue'] }}" 
						(click)="goNext()" 
						(keydown.enter)="goNext()" 
						[disabled]="!canContinue()"
					></rcg-primary-button>
				</div> 
			</rcl-button-group>
		</div>
		</ng-container>
	}
</rcl-main-content>
	
@if (shouldDisplayMessageCenter) {
<main-nav-message-center-box></main-nav-message-center-box>
}
